export default function hamburgerMenu() {
  const { body } = document;
  const headerNav = document.getElementById('js-headerNav');
  const headerHamburger = document.getElementById('js-headerButton');
  headerHamburger.addEventListener('click', function() {
    this.classList.toggle('is-active');
    headerNav.classList.toggle('is-active');

    if (headerNav.classList.contains('is-active')) {
      body.style.overflowY = 'hidden';
    } else {
      body.style.overflowY = 'auto';
      headerNav.scrollTop = 0;
    }
  });
}
